module.exports = __webpack_public_path__ + "h5/img/get-lottery-size.fbe34227.png";